import { Navigate } from "react-router-dom";
import { Network } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/stores/authStore";
import { beginSignIn } from "@/lib/oidc";
import { toast } from "@/hooks/useToast";

// Marketing lives on the separate Astro site — the SPA is app-only and must
// not duplicate it. See docs/roadmap.md.
const MARKETING_URL = "https://tabgraph.stratusstudios.com";
const INSTALL_URL = `${MARKETING_URL}/#install`;

export function IndexPage() {
  const { isSignedIn } = useAuthStore();

  if (isSignedIn) return <Navigate to="/sessions" replace />;

  async function handleSignIn() {
    try {
      const redirectUri = `${window.location.origin}/auth/callback`;
      await beginSignIn(redirectUri, "/sessions");
    } catch (err) {
      toast({
        variant: "destructive",
        title: "Sign in failed",
        description: err instanceof Error ? err.message : "Unknown error",
      });
    }
  }

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-8 px-4 text-center">
      <div className="flex flex-col items-center gap-3">
        <Network className="h-10 w-10 text-primary" />
        <h1 className="text-2xl font-semibold tracking-tight">Tabgraph</h1>
      </div>

      <Button size="lg" onClick={() => { void handleSignIn(); }}>
        Sign in
      </Button>

      <div className="flex flex-col items-center gap-1 text-sm text-muted-foreground">
        <a href={MARKETING_URL} className="underline-offset-4 hover:underline">
          What is Tabgraph?
        </a>
        <a href={INSTALL_URL} className="underline-offset-4 hover:underline">
          Install the extension
        </a>
      </div>
    </div>
  );
}
